import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class PreviewScheduleService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetRoomPreview(data) {
        return this.http.post('/api/PreviewSchedule/PreviewRoom', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetRoomPreviewAlerts(data) {
        return this.http.post('/api/PreviewSchedule/RoomAlerts', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetPivotData(data) {
        return this.http.post('/api/PreviewSchedule/PreviewPivotData', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetPreviewReports(appOptId) {
        return this.http.get('/api/PreviewSchedule/GetPreviewReports', { params: { appOptId: appOptId }}).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SavePreviewReport(data) {
        return this.http.post('/api/PreviewSchedule/SavePreviewReport', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    StaffPlaygroundDialog(data) {
        return this.http.post('/api/PreviewSchedule/StaffPlaygroundDialog', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    AssignToRackDialog(data) {
        return this.http.post('/api/PreviewSchedule/AssignToRackDialog', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    StaffPlaygroundAction(data) {
        return this.http.post('/api/PreviewSchedule/StaffPlaygroundAction', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    StaffPlaygroundChanges(reportId) {
        return this.http.get('/api/PreviewSchedule/StaffPlaygroundChanges?reportId=' + reportId).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    StaffPlaygroundData(reportId) {
        return this.http.get('/api/PreviewSchedule/StaffPlaygroundData?reportId=' + reportId).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    ApplyStaffPlayground(data) {
        return this.http.post('/api/PreviewSchedule/ApplyStaffPlayground', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
